import store from '@/store'
import axios from 'axios'
import { Message } from 'element-ui'
import util from '@/libs/util'
import router from '@/router'
import { requestWhite } from '@/assets/variable'

// 判断请求白名单
function isWhite(url) {
  return requestWhite.some((item) => {
    // console.log(url)
    return url.includes(item)
  })
}
// 判断不需要判断刷新token的url
function isNorefresh(url) {
  return ['/user/oprSysUser/info', '/user/oprSysUser/refreshToken'].some(
    (item) => {
      // console.log(url)
      return url.includes(item)
    }
  )
}
// 创建一个错误
function errorCreate(msg) {
  const error = new Error(msg)
  errorLog(error)
  throw error
}

// 记录和显示错误
function errorLog(error) {
  // 添加到日志
  store.dispatch('d2admin/log/push', {
    message: '数据请求异常',
    type: 'danger',
    meta: {
      error,
    },
  })
  // 打印到控制台
  if (process.env.NODE_ENV === 'development') {
    util.log.danger('>>>>>> Error >>>>>>')
    console.log(error)
  }
  // 显示提示
  Message({
    message: error.message,
    type: 'error',
    duration: 5 * 1000,
  })
}

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 10000, // 请求超时时间
})

// 请求拦截器
service.interceptors.request.use(
  (config) => {
    // 在请求发送之前做一些处理
    // 白名单token传空
    // console.log('AuthorizationAuthorization', util.cookies.get('token'))
    const matchId = store.getters['d2admin/user/getMatchStatus'].matchId

    if (isWhite(`/${config.url}`)) {
      config.headers['Authorization'] = ''
      // 偶尔也有在白名单但是需要token的情况……
      if (config.needToken) {
        const Authorization = util.cookies.get('token')
        config.headers['matchId'] = matchId
        config.headers['Authorization'] = Authorization
      }
    } else {
      // console.log('不在白名单')
      const Authorization = util.cookies.get('token')

      if (Authorization) {
        config.headers['matchId'] = matchId
        config.headers['Authorization'] = Authorization
      }
    }

    if (config.method === 'post') {
      config.data = {
        ...config.data,
        matchId,
      }
    } else {
      config.params = { ...config.params, matchId }
    }
    // console.log(config, 'ajax配置')

    return config
  },
  (error) => {
    // 发送失败

    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  async (response) => {
    const Authorization = util.cookies.get('token')

    if (Authorization) {
      // 判断token是否快过期，快过期刷新token
      const expireTime = util.cookies.get('expireTime') // 过期时间
      const nData2 = new Date(Date.parse(new Date()) + 2 * 3600 * 1000)

      if (
        Date.parse(nData2) > Date.parse(expireTime) &&
        !isNorefresh(response.config.url)
      ) {
        // 去刷新token去
        console.log('去刷新token去___________')
        await store.dispatch('d2admin/account/refreshToken', {})
      }
    }

    // console.log('response:', response)
    // dataAxios 是 axios 返回数据中的 data
    const dataAxios = response.data
    // 这个状态码是和后端约定的
    const { code } = dataAxios
    // 根据 code 进行判断
    if (code === undefined) {
      // 如果没有 code 代表这不是项目后端开发的接口 比如可能是 D2Admin 请求最新版本
      return dataAxios
    } else {
      // 有 code 代表这是一个后端接口 可以进行进一步的判断
      switch (parseInt(code)) {
        case 0:
          // [ 示例 ] code === 0 代表没有错误
          return dataAxios
        case 401:
          // token失效
          Message({
            message: '身份凭证失效，请重新登录，3秒后将跳转至登录页！',
            type: 'error',
            duration: 5 * 1000,
          })
          util.cookies.remove('token')
          util.cookies.remove('uuid')
          localStorage.removeItem('member_match_id')
          localStorage.removeItem('match_match_id')
          setTimeout(function () {
            router.push({
              name: 'login',
            }) // 为了重新实例化vue-router对象 避免bug
          }, 2000)
          break
        case 5003:
          return dataAxios
        case 5002:
          return dataAxios
        case 300:
          return dataAxios
        case 5001:
          return dataAxios
        case 4001:
          // token失效
          Message({
            message: '身份凭证失效，请重新登录，3秒后将跳转至登录页！',
            type: 'error',
            duration: 5 * 1000,
          })
          // console.log()
          util.cookies.remove('token')
          util.cookies.remove('uuid')
          localStorage.removeItem('member_match_id')
          localStorage.removeItem('match_match_id')
          setTimeout(function () {
            router.push({
              name: 'login',
            }) // 为了重新实例化vue-router对象 避免bug
          }, 3000)
          break

        case 500:
          // 错误
          Message.closeAll()
          Message({
            message: dataAxios.msg,
            type: 'error',
            duration: 5 * 1000,
          })
          return dataAxios
        // case 'xxx':
        //   // [ 示例 ] 其它和后台约定的 code
        //   errorCreate(`[ code: xxx ] ${dataAxios.msg}: ${response.config.url}`)
        //   break
        default:
          // 不是正确的 code
          errorCreate(`${dataAxios.msg} `)
          // Message({
          //   message: dataAxios.msg,
          //   type: 'error',
          //   duration: 5 * 1000
          // })
          break
      }
    }
  },
  (error) => {
    if (error.message.includes('timeout')) {
      // 判断请求异常信息中是否含有超时timeout字符串
      error.message = '网络连接超时，请检查您的网络连接情况'
      errorLog(error)
      return Promise.reject(error)
    }
    if (error && error.response) {
      switch (error.response.status) {
        case 400:
          error.message = '请求错误'
          break
        case 401:
          error.message = '身份凭证失效，请重新登录，3秒后将跳转至登录页！'
          util.cookies.remove('token')
          util.cookies.remove('uuid')
          setTimeout(function () {
            router.push({
              name: 'login',
            }) // 为了重新实例化vue-router对象 避免bug
          }, 3000)
          break
        case 403:
          error.message = '拒绝访问'
          break
        case 404:
          error.message = `请求地址出错: ${error.response.config.url}`
          break
        case 408:
          error.message = '请求超时'
          break
        case 500:
          error.message = '服务器内部错误'
          break
        case 501:
          error.message = '服务未实现'
          break
        case 502:
          error.message = '网关错误'
          break
        case 503:
          error.message = '服务不可用'
          break
        case 504:
          error.message = '网关超时'
          break
        case 505:
          error.message = 'HTTP版本不受支持'
          break
        default:
          break
      }
    }
    errorLog(error)
    return Promise.reject(error)
  }
)

export default service
